// src/DynamicFaviconAndTitle.jsx
import React, { useEffect } from "react";
import { getBranding } from "./utils/getBranding";
// import { getBranding } from "./utils/branding"; // adjust path if needed

function DynamicFaviconAndTitle() {
  useEffect(() => {
    const branding = getBranding();

    // Set document title
    document.title = branding.brandName;

    // Remove old favicons and other icon-related links
    const oldIcons = document.querySelectorAll("link[rel*='icon']");
    oldIcons.forEach(icon => icon.remove());

    // Add new favicon
    const newFavicon = document.createElement("link");
    newFavicon.rel = "icon";
    newFavicon.href = branding.favicon || branding.logo;
    document.head.appendChild(newFavicon);

    // Also update apple-touch-icon if you want
    const appleIcon = document.createElement("link");
    appleIcon.rel = "apple-touch-icon";
    appleIcon.href = branding.favicon || branding.logo;
    document.head.appendChild(appleIcon);
  }, []);

  return null;
}

export default DynamicFaviconAndTitle;
